<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="activityName" placeholder="活动名称"></el-input>
                        <el-input v-model="activityWayName" placeholder="赛道名称"></el-input>
                        <el-input v-model="worksCode" placeholder="作品编码"></el-input>
                        <el-select v-model="activityStatus" placeholder="评分状态">
                            <el-option label="未评分" value="false">未评分</el-option>
                            <el-option label="已评分" value="true">已评分</el-option>
                        </el-select>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <el-table
                            :data="tableData"
                            border
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                prop="activityName"
                                label="活动名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="作品名称"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="code"
                                label="作品编码"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                label="作品提交时间"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="activityWayName"
                                align="center"
                                header-align="center"
                                label="赛道名称">
                            </el-table-column>
                            <el-table-column
                                prop="typeName"
                                align="center"
                                header-align="center"
                                label="作品类别">
                            </el-table-column>
                            <el-table-column
                                prop="signType"
                                align="center"
                                header-align="center"
                                label="参赛主体">
                                <template slot-scope="scope">
                                    {{ scope.row.signType==='PERSONAL'?'个人':'团队' }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="reviewStatus"
                                align="center"
                                header-align="center"
                                label="评分状态" width="120">
                                <template slot-scope="scope">
                                    {{ scope.row.reviewScore==null?'未评分':'已评分' }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="reviewScore"
                                align="center"
                                header-align="center"
                                label="评委评分" width="120">
                                <template slot-scope="scope">
                                    {{ scope.row.reviewScore==null?'':scope.row.reviewScore }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" v-if="scope.row.reviewScore==null" @click="toDialog(scope.row.uuid)">作品打分</el-button>
                                    <el-button type="text" size="small" @click="toDetail(scope.row.uuid)">查看</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!--审核-->
        <examine-review-dialog ref="examineReviewDialogRef" @submit="getList"></examine-review-dialog>
        <!--查看-->
        <details-dialog ref="detailsDialogRef"></details-dialog>
    </div>
</template>

<script>
import { getWorksReviewList } from '../../utils/interface';
// 评分
import examineReviewDialog from '../examine/examineReviewDialog'
// 查看
import detailsDialog from '../examine/detailsDialog'
export default {
    components: {examineReviewDialog,detailsDialog},
    data() {
        return {
            dialogFormVisible:false,
            activityName: '',
            activityStatus: '',
            tableData: [],
            current: 1,
            pageSize: 10,
            total: 0,
            uuid:'',
            reviewScore:0.00,
            worksCode:'',
            activityWayName: '',
        }
    },
    computed: {
        contentViewHeight() {
            let height = document.documentElement.clientHeight - 120
            return {minHeight: height + 'px'}
        },
    },
    created() {
        this.getList();
    },
    methods: {
        getList(){
            let params = {
                activityName:this.activityName,
                code: this.worksCode,
                activityWayName: this.activityWayName,
                reviewStatus:this.activityStatus,
                current:this.current,
                pageSize:this.pageSize,
            }
            getWorksReviewList(params).then((res)=>{
                this.tableData = res.list;
                this.current = res.current;
                this.total = res.total;
            });
        },
        resetData(){
            this.activityName = '';
            this.activityStatus = '';
            this.worksCode = '';
            this.activityWayName = ''
            this.getList();
        },
        // 分页
        handleCurrentChange(val){
            this.current = val;
            this.getList();
        },
        search(){
            this.current = 1;
            this.getList();
        },
        // 新增/编辑
        toDialog(uuid){
            //this.uuid = uuid;
            //this.dialogFormVisible = true;
            this.$refs.examineReviewDialogRef.init(uuid);
        },
        // 查看
        toDetail(uuid){
            this.$refs.detailsDialogRef.init(uuid,1);
        },
    }
}
</script>

<style scoped lang="less">
    .orderManagementClass {
        position: relative;
        width: 100%;
        padding: 0 20px 20px;
        .orderManagementContent {
            background: #fff;
            .printOrderListBox {
                padding: 20px;
                .orderSearchBox {
                    display: flex;
                    flex-wrap: wrap;

                    /deep/ .el-input {
                        width: initial;
                        margin-bottom: 22px;
                        margin-right: 30px;
                    }

                    /deep/ .el-input__inner {
                        width: 242px;
                        height: 35px;
                        min-height: 35px;
                        font-size: 12px;
                        color: #999999;
                        background-color: #f2f4f7;
                        border: 1px solid #f2f4f7;
                        border-radius: 5px;

                        &:hover,
                        &:focus {
                            background-color: #fff;
                            border: 1px solid #108ee9;
                        }
                    }

                    /deep/ .el-input__prefix {
                        top: -3px;
                    }

                    /deep/ .el-input__suffix {
                        top: 2px;
                    }

                    /deep/ .el-button {
                        display: block;
                        line-height: 35px;
                        padding: 0;
                        height: 35px;
                    }

                    .searchBtn {
                        width: 82px;
                        background: #3d7fff;
                        border: none;
                        border-radius: 15px;
                        font-size: 14px;
                        color: #ffffff;
                    }

                    .resetBtn {
                        color: #333333;
                    }
                }

                .tableContent {
                    // min-height: 650px;

                    /deep/ .el-table__header {
                        tr {
                            th {
                                border-right: none;
                            }
                        }

                        /deep/ .el-table__cell {
                            padding: 5px 0;
                            background: #f2f5fc;
                        }
                    }

                    /deep/ .el-table__body {
                        img {
                            vertical-align: middle;
                            width: 52px;
                            height: 50px;
                        }
                    }
                }

                .pagination {
                    margin-top: 20px;
                    text-align: right;
                }
            }
        }
        .tableTool {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: 20px;
            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }
        .dialogBox{
            .details{
                .detailsItem{
                    padding-bottom: 20px;
                    h3{
                        font-weight: 700;
                        font-size: 16px;
                        color: #000;
                        margin-top: 0;
                        letter-spacing: 1px;
                        border-bottom: 1px solid #ddd;
                        padding-bottom: 15px;
                    }
                    .itemContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        .one-row{
                            width: 50%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                        .two-row{
                            width: 100%;
                            margin-bottom: 22px;
                            display: flex;
                            .label{
                                padding-right: 15px;
                                min-width: 95px;
                            }
                            .name{
                                color: #000;
                            }
                        }
                    }
                    .itemPictureContent{
                        display: flex;
                        flex-wrap: wrap;
                        font-size: 15px;
                        padding: 0 30px;
                        justify-content: space-between;
                        .one-row{
                            width: 30%;
                            margin-bottom: 22px;
                            img{
                                width: 100%;
                                height: 138px;
                                border: 1px solid #ddd;
                            }
                            .name{
                                text-align: center;
                                padding-top: 10px;
                                font-size: 14px;
                                display: flex;
                                .label{
                                    min-width: 80px;
                                }
                            }
                        }
                    }
                }
            }
            .audit{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .auditContent{
                    padding: 0 30px;
                }
                .cause{
                    display: flex;
                    margin-top: 20px;
                    .causeTitle{
                        min-width: 80px;
                        color: #3a8ee6;
                    }
                    .causeContent{
                        color: #000;
                    }
                }
                .auditEnter{
                    text-align: center;
                    padding-top: 20px;
                    button{
                        width: 120px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/examine/examineCenter.vue